// extracted by mini-css-extract-plugin
module.exports = {"section_container":"AuctionPageLeftPane_section_container__1WD8U"};